<div class="p-2 flex justify-center">
	<mat-form-field class="w-1/2" color="primary" subscriptSizing="dynamic">
		<mat-label>Search</mat-label>
		<input
			id="user-searchbar"
			type="text"
			(keyup)="applyFilter($event)"
			placeholder="Search by name, email or phone number."
			matInput
			#searchInput
		/>
	</mat-form-field>
	<button mat-mini-fab color="primary" class="absolute left-0 top-0 mt-2 ml-2" (click)="openCreateRoleModal()">
		<mat-icon>add</mat-icon>
	</button>
</div>

<div class="w-3/4 h-full border-gray-700 border-2 rounded overflow-auto m-auto">
	<table mat-table [dataSource]="dataSource" multiTemplateDataRows class="w-full" matSort *ngIf="!isLoadingRoles">
		<!--Name Column-->
		<ng-container matColumnDef="name">
			<th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name" class="transit-column">Name</th>
			<td mat-cell *matCellDef="let role">
				{{ role.name }}
			</td>
		</ng-container>

		<!--Description Column-->
		<ng-container matColumnDef="description">
			<th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by description" class="transit-column">
				Description
			</th>
			<td mat-cell *matCellDef="let role">
				{{ role.description }}
			</td>
		</ng-container>

		<!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns. -->
		<ng-container matColumnDef="expandedDetail">
			<td mat-cell *matCellDef="let role" [attr.colspan]="columnsToDisplay.length">
				<div class="overflow-hidden flex" [@detailExpand]="role.expanded ? 'expanded' : 'collapsed'">
					<app-roles-list-detail [role]="role" class="w-full"></app-roles-list-detail>
				</div>
			</td>
		</ng-container>
		<tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
		<tr
			mat-row
			*matRowDef="let time; let i = dataIndex; columns: columnsToDisplay"
			class="role-row cursor-pointer"
			(click)="time.expanded = !time.expanded"
		></tr>
		<tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
		<!-- Row shown when there is no matching data. -->
		<tr class="mat-row flex" *matNoDataRow>
			<td class="mat-cell p-4" colspan="4" *ngIf="!isLoadingRoles">No data matching the filter "{{ searchInput.value }}"</td>
		</tr>
	</table>
	<div class="h-full w-full flex justify-center align-middle items-center" *ngIf="isLoadingRoles">
		<mat-spinner></mat-spinner>
	</div>
</div>
